import { all, takeEvery, call, put } from 'redux-saga/effects';
import actions from './actions';
import SuperFetch from '../../helpers/superFetch';
import { apiUrls } from '../../settings';

// DO_CONFIRM
const doConfirmEmail = async (hash) => {
  const body = {
    data: { hash },
  };
  return await SuperFetch.post(apiUrls.confirmEmail, body)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* confirmEmail(payload) {
  const response = yield call(doConfirmEmail, payload.payload);
  if (response && response.result === 'success') {
    yield put(actions.doConfirmEmailSucceeded(response));
  } else {
    yield put(actions.doConfirmEmailFailed(response));
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.DO_CONFIRM_EMAIL, confirmEmail),
  ]);
}


// WEBPACK FOOTER //
// ./src/redux/confirm/sagas.js